<!-- eslint-disable -->
<template lang="pug">
    .battle-waiting
        img.battle-waiting__turtle(:src="turtleImage")
        cs-loader(v-if="isLoading")
        .battle-waiting__grid(v-else)
            .battle-waiting__grid-col
                battle-box
                    template(slot="top")
                        battle-preview(
                            :battle="battle",
                            :withTime="true",
                            :showStatus="true"
                        )
                        .battle-waiting__button-group
                            cs-button.battle-waiting__button.battle-waiting__button--background-white(
                                pattern="primary-outline",
                                @click="showUsers"
                            )
                                span(v-text="participantsCountText")
                            cs-button.battle-waiting__button.battle-waiting__button--background-white(
                                v-if="isShowEditButton",
                                pattern="primary-outline",
                                @click="editBattle"
                            )
                                | {{ $i18n.t('battle.battle_edit_editBattle') }}
                            cs-button.battle-waiting__button.battle-waiting__button--background-white(
                                v-if="user.isSuperadmin || user.isManagerOrSupport",
                                pattern="primary-outline",
                                @click="deleteBattle"
                            )
                                | {{ $i18n.t('battle.battle_edit_deleteBattle') }}
            .battle-waiting__grid-col.battle-waiting__button-group.battle-waiting__bottom-button
                router-link(:to=`{name: 'battles:index'}`)
                    cs-button.battle-waiting__button(pattern="primary-inverse") {{ $i18n.t('battle.battle_showPage_toBattlesList') }}
            .battle-waiting__grid-col.battle-waiting__button-group.battle-waiting__bottom-button
                router-link(:to=`{name: 'dashboard'}`)
                    cs-button.battle-waiting__button(pattern="primary-dark-outline") {{ $i18n.t('common.common_navigation_exit') }}
</template>

<script>
    /*eslint-disable*/
    import BattleBox from './Box.vue';
    import BattlePreview from './Preview.vue';
    import OlympiadApi from '../../api/olympiad';
    import { mapState } from 'vuex';
    import _ from 'lodash';
    import moment from 'moment';
    import PensiveTurtle from '../../assets/images/PensiveTurtle.svg';
    import TurtleWithCup from '../../assets/images/TurtleWithCup.svg';
    import BattleApi from '../../api/battle';

    const { noun } = require('plural-ru');

    const timezone = 'Europe/Moscow';

    export default {
        props: {
            id: [Number, String],
        },
        data() {
            return {
                isLoading: true,
                battle: null,
                level: null,
                timer: null,
                isToday: null,
                showCountdown: false,
                startSoundPlayed: false,
                isSoundLoaded: false,
            };
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                course: state => state.trainer.course,
            }),
            momentDuration() {
                return this.level ? moment.duration(this.level.secondsToStart, 'seconds') : null;
            },
            timeToStart() {
                let hours = this.momentDuration.hours();
                let minutes = this.momentDuration.minutes();
                let seconds = this.momentDuration.seconds();
                let resultString = '';
                if (hours) {
                    resultString +=
                        hours + ' ' + this.$i18n.tc('olympiads.olympiads_timeDeclination_hours', hours) + ' ';
                }
                if (minutes) {
                    resultString +=
                        minutes + ' ' + this.$i18n.tc('olympiads.olympiads_timeDeclination_minutes', minutes) + ' ';
                }
                resultString += seconds + ' ' + this.$i18n.tc('olympiads.olympiads_timeDeclination_seconds', seconds);
                return resultString;
            },
            participantsCountText() {
                return (
                    this.battle.participantsCount +
                    ' ' +
                    this.$i18n.tc('olympiads.olympiads_showPage_participantDeclination', this.battle.participantsCount)
                );
            },
            turtleImage() {
                if (this.user.type === 'student' && this.level) {
                    if ((this.isToday && this.level.secondsToStart <= 0) || this.level.isCompleted) {
                        return TurtleWithCup;
                    }
                    return PensiveTurtle;
                }
                return '';
            },
            isShowEditButton() {
                return this.user.isSuperadmin || this.user.isManagerOrSupport;
            },
        },
        mounted() {
            this.fetchData();
        },
        methods: {
            fetchData() {
                this.isLoading = true;
                return BattleApi.show(this.id, { course_type: _.kebabCase(this.course) })
                    .then(battle => {
                        this.battle = battle;
                        if (this.user.type === 'student') {
                            this.battle.levels.forEach(level => {
                                if (level.authRegisteredUser[0]) {
                                    this.level = level;
                                    this.timer = setInterval(() => {
                                        --this.level.secondsToStart;
                                        !this.level.secondsToStart && clearInterval(this.timer);
                                    }, 1000);
                                }
                            });
                            if (this.battle.status === 'archived') {
                                this.$router.push({ name: 'battle:results', params: { id: this.id } });
                            } else if (
                                this.user.type === 'student' &&
                                !this.level &&
                                this.battle.isRegistrationAllowed
                            ) {
                                this.$router.push({ name: 'battle:register', params: { id: this.id } });
                            }
                        }
                        this.isLoading = false;
                        if (this.level) {
                            this.loadSounds().then(() => {
                                this.isSoundLoaded = true;
                            });
                        }
                    })
                    .catch(err => {
                        if (err.data && err.data.status_code === 403) {
                            this.$toasted.error(this.$root.$t('errors.olympiad_no_access'));
                            this.$router.push({ name: 'dashboard' });
                        } else {
                            this.$toasted.error(this.$root.$t('errors.getting_olympiadList'));
                        }
                    });
            },
            editBattle() {
                this.$router.push({ name: 'battle:edit', params: { battleId: this.id } });
            },
            deleteBattle() {
                BattleApi.delete(this.id)
                    .then(response => {
                        this.$toasted.success(this.$root.$t('battle.battle_deleted'));
                        this.$router.push({ name: 'battles:index' });
                    })
                    .catch(err => {
                        if (err.data && err.data.status_code === 403) {
                            this.$toasted.error(this.$root.$t('errors.olympiad_no_access'));
                        } else {
                            this.$toasted.error(this.$root.$t('errors.deleting_battle'));
                        }
                        this.$router.push({ name: 'dashboard' });
                    });
            },
            showUsers() {
                //todo: make logic
                //this.$router.push({ name: 'battle:students-list', params: { id: this.id } });
            },
            loadSounds() {
                return new Promise(resolve => {
                    let sound = OlympiadApi.getStartSound();
                    this.$createjs.Sound.removeAllSounds();
                    this.$createjs.Sound.removeAllEventListeners();
                    this.$createjs.Sound.addEventListener('fileload', resolve);
                    this.$createjs.Sound.alternateExtensions = ['mp3'];
                    this.$createjs.Sound.registerSound(sound);
                });
            },
            openCountdown() {
                this.showCountdown = true;
            },
        },
        beforeRouteLeave(to, from, next) {
            if (!to.name.includes('battle')) {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
            }
            if (this.timer) {
                clearInterval(this.timer);
            }
            next();
        },
        components: {
            BattleBox,
            BattlePreview,
        },
    };
</script>

<style lang="scss" scoped>
    .fade--enter-active,
    .fade--leave-active {
        transition: opacity 0.6s;
    }
    .fade--enter,
    .fade--leave-to {
        opacity: 0;
    }
    .fade--enter-to,
    .fade--leave {
        opacity: 1;
    }

    .battle-waiting {
        &__grid {
            @include make-grid(0);
        }

        &__turtle {
            position: fixed;
            max-height: 50vh;
            max-width: 30vw;
            right: 5%;
            bottom: 5%;
        }

        &__grid-col {
            @include stack-space($space-large);
            @include make-col(12, 12, 0);
            @include media($sm) {
                @include make-offset(1, 12);
                @include make-col(10, 12, 0);
            }
            @include media($lg) {
                @include make-offset(2, 12);
                @include make-col(8, 12, 0);
            }
            @include media($xlg) {
                @include make-offset(3, 12);
                @include make-col(6, 12, 0);
            }
        }

        &__button-group {
            display: flex;
            justify-content: center;
            flex-direction: column;
            @include media($md) {
                flex-direction: row;
            }
        }
        &__button {
            margin-bottom: 10px;
            @include media($md) {
                padding: 15px 20px !important;
                margin-bottom: 0;
                margin-right: 10px;
                &:last-child {
                    margin-right: 0;
                }
            }
            &--background-white {
                background-color: $x-color-white;
            }
        }
        &__box-bottom {
            text-align: center;
        }
        &__timer {
            color: $color-brown-500;
            &-title {
                @include text($font-size-14);
            }
            &-time {
                @include text($font-size-16, $font-weight-semi-bold);
            }
        }
    }
    .battle-waiting__bottom-button {
        text-align: center;
    }
</style>
